module.exports = __webpack_public_path__ + "img/ellipse-inside-blur-blue-s.c210bba8.svg";